import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import belanceReducer from './belanceSlice';
import customerReducer from './customerSlice';
import moneyReducer from './moneysSlice';
import itemReducer from './itemSlice';
import settingReducer from './settingSlice';
import stockReducer from './stockSlice';
import userReducer from './userSlice';
import sidebarReducer from './sidebarSlice';
import tailorReducer from './tailorSlice';
import expenseCategoryReducer from './expenseCategorySlice';

import { financeApi } from './financeApi'; // ✅ مهم

// فقط slice ها persist شوند (نه api)
const persistConfig = {
  key: 'root',
  storage,
  whitelist: [
    'belances',
    'customers',
    'moneys',
    'items',
    'settings',
    'stocks',
    'users',
    'sidebars',
    'tailors',
    'expenseCategories'
  ]
};

const rootReducer = combineReducers({
  belances: belanceReducer,
  customers: customerReducer,
  moneys: moneyReducer,
  items: itemReducer,
  settings: settingReducer,
  stocks: stockReducer,
  users: userReducer,
  sidebars: sidebarReducer,
  tailors: tailorReducer,
  expenseCategories: expenseCategoryReducer,

  // ✅ RTK Query reducer
  [financeApi.reducerPath]: financeApi.reducer
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(financeApi.middleware) // ✅ RTK middleware
});

export const persistor = persistStore(store);
